import Client from '../../../services/client';
import type { ConfirmPaymentInfo } from '../../../types';

interface ConfirmLinePayTransactionProps {
  confirmPaymentInfo: ConfirmPaymentInfo;
}

export const confirmLinePayTransaction = async ({
  confirmPaymentInfo,
}: ConfirmLinePayTransactionProps) => {
  const { data } = await Client.apsGetOrder({
    parkingTicketId: confirmPaymentInfo.parking_ticket_id as string,
    parkingOrderId: confirmPaymentInfo?.parking_order_id as string,
  });

  return data;
};
